module.exports = __webpack_public_path__ + "media/images/vp/icon.checkbox.off.gray-1461a8e536e7dabcf2879e02aa3c1b52.svg";